module.exports = __webpack_public_path__ + "static/media/CRC35.fcff34ec.otf";